export { };

export class Toaster {
  public static info(text: string, heading?: string) {
    $.toast({
      heading: heading,
      text: text,
      position: "bottom-left",
      loader: false,
      hideAfter: 2000,
      allowToastClose: false,
      showHideTransition: "slide"
      // icon: "success"
    });
  }

  public static alert(text: string, heading?: string) {
    $.toast({
      heading: heading,
      text: text,
      position: "top-center",
      loader: false,
      allowToastClose: true,
      bgColor: '#fff3cd', // doesn't work, broken somewhere else
      textColor: '#997404',
      showHideTransition: "slide"
    });
  }

  public static error(text: string) {
    $.toast({
      heading: "Error",
      text: text,
      position: "bottom-left",
      loader: false,
      hideAfter: 2000,
      allowToastClose: false,
      showHideTransition: "slide"
    });
  }

  public static tradeSuccess(heading: string, text: string) {
    $.toast({
      heading: heading,
      text: text,
      position: "bottom-left",
      loaderBg: "#5ba035",
      hideAfter: 2000,
      allowToastClose: false,
      showHideTransition: "slide"
    });
  }

  public static tradeInfo(heading: string, text: string) {
    $.toast({
      heading: heading,
      text: text,
      position: "bottom-left",
      loaderBg: "#5ba035",
      hideAfter: 2000,
      allowToastClose: false,
      showHideTransition: "slide"
    });
  }

  public static tradeError(text: string, afterShown?: () => any) {
    $.toast({
      heading: "Error",
      text: text,
      position: "bottom-left",
      loaderBg: "#bf441d",
      hideAfter: 2000,
      allowToastClose: false,
      showHideTransition: "slide",
      afterShown: afterShown
    });
  }
}
